import React from 'react';
import PropTypes from 'prop-types';
import { Button as ButtonUI } from 'xland-ui';

function Button({
  text = '',
  color = 'primary',
  type = 'button',
  disabled = false,
  loading = false,
  size = '',
  mode = '',
  onClick = () => {},
  className = '',
  style = null,
  icon = null,
  iconRight = null,
}) {
  return (
    <ButtonUI
      text={text}
      variant={color}
      type={type}
      disabled={disabled}
      loading={loading}
      size={size}
      mode={mode}
      onClick={onClick}
      className={className}
      style={style}
      icon={icon}
      iconRight={iconRight}
    />
  );
}

Button.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.string,
  mode: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  icon: PropTypes.any,
  iconRight: PropTypes.any,
};

export default Button;
